module.exports = __webpack_public_path__ + "static/media/pg_dnm_low_tide.a42fc148.jpg";